export default "__VITE_ASSET__FA7EOIBV__"